import { AddChangeLogEntryFormData } from '../../../../entities/ChangeLog/ChangeLog'
import {
    FormErrors,
    FormValidation,
    validateForm,
    validateRequiredString,
    validateVersionString,
} from '../../../../services/validationService'

export type AddChangeLogEntryFormErrors = FormErrors<AddChangeLogEntryFormData>

export const validateAddChangeLogEntryFormData = (
    formData: AddChangeLogEntryFormData,
): FormValidation<AddChangeLogEntryFormErrors> => {
    const errors: AddChangeLogEntryFormErrors = {
        version: validateVersionString('version', formData.version),
        changes: validateRequiredString('changes', formData.changes),
        // `date` is not listed here as it is derived from DateInput + TimeInput, which can't produce an invalid value.
    }

    return validateForm<AddChangeLogEntryFormErrors>(errors)
}
